/**
 * Authentication Manager
 * Handles authentication errors and callbacks for the application
 */
export const authManager = {
  setAuthErrorCallback: null,

  setAuthError(error) {
    if (this.setAuthErrorCallback) {
      this.setAuthErrorCallback(error);
    }
  },

  clearAuthError() {
    if (this.setAuthErrorCallback) {
      this.setAuthErrorCallback(null);
    }
  }
};
